export enum EvaluationModuleSlug {
  SENSOPROFILE = 'SENSOPROFILE',
  MOTPROFILE = 'MOTPROFILE',
  EDUCPROFILE = 'EDUCPROFILE',
}
